'use strict';

const trackingUtils = require('../utils/tracking.utils');
const SeatsTracking = require('../../tracking/bags_and_seats/seats_tracking').getInstance();
const flowType = Odigeo.SessionScope.flow;
const oneClickCheckoutFactory =
    require(`components/one_click_checkout/js/main.${flowType === 'desktop' ? 'desktop' : 'mobile'}`);

const CATEGORY = 'my_area_trips_details';

module.exports = {
    translations: null,
    isOpen: false,
    isPriceBreakdownOpen: false,
    oneClickCheckoutContainer: null,

    selectors: {
        widget: '.post_booking_seats_widget',
        waiting: '.post_booking_seats_waiting',
        content: '.post_booking_seats_content',
        flightInfo: '.post_booking_flight_info',
        seatMap: '.post_booking_seats_seatmap',
        info: '.post_booking_seats_info',
        payment: '.post_booking_seats_payment',
        oneClickCheckout: '.one_click_checkout',
        purchase: '.post_booking_seats_purchase',
        body: '.post_booking_seats_body',
        headerTitle: '.post_booking_seats_header_title',
        back: '.post_booking_ancillaries_back',
        checkout: '.post_booking_seats_checkout',
        success: '.post_booking_seats_confirmation_success',
        paymentFailure: '.post_booking_seats_payment_failure',
        failure: '.post_booking_seats_failure',
        footerBack: '.post_booking_seats_footer_back',
        checkoutButton: '.post_booking_seats_checkout_button',
        priceBreakdown: '.post_booking_price_breakdown_toggle',
        purchaseButton: '.post_booking_purchase_purchase_button',
        translations: '.post_booking_seats_translations',
        phoneNumber: '.post_booking_seats_confirmation_contact_phone_number',
    },
    tmpls: {
        waitingTemplate: '#post_booking_seats_waiting_template',
        infoTemplate: '#post_booking_seats_info_template',
        flightSectionInfoTemplate: '#post_booking_flight_section_info_template',
        checkoutTemplate: '#post_booking_seats_checkout_template',
        priceBreakdownItemTemplate: '#post_booking_price_breakdown_item_template',
        priceBreakdownTemplate: '#post_booking_price_breakdown_template',
        purchaseTemplate: '#post_booking_seats_purchase_template',
        noCoverageTemplate: '#post_booking_generic_message_template',
    },
    events: {
        'tap @back': 'onTapBack',
        'tap @footerBack': 'onTapBack',
        'tap @checkoutButton': 'onCheckout',
        'tap @priceBreakdown': 'onPriceBreakdownToggle',
        'tap @purchaseButton': 'onPurchase',
        'tap @phoneNumber': 'onTapPhoneNumber',
    },

    init: function() {
        this.tmpls = Odigeo.Utils.getTemplates(this.$el, this.tmpls);
        this.translations = Odigeo.Utils.parseJson(this.$cachedSelectors.translations.html());
        if (Odigeo.AB.isOneClickCheckout) {
            this.createOneClickCheckout();
        }
    },

    createOneClickCheckout() {
        this.oneClickCheckoutContainer = oneClickCheckoutFactory.create({
            el: this.$el.find(this.$cachedSelectors.oneClickCheckout),
            id: 'one-click-checkout-post-booking-seats',
            productType: 'SEAT',
            contentKeys: {
                feedbackConfirmationTitle: 'seatsConfirmationTitle',
                feedbackConfirmationSubtitle: 'seatsConfirmationSubtitle',
                feedbackConfirmationButton: 'seatsConfirmationButton',
                feedbackErrorTitle: 'seatsErrorTitle',
                feedbackErrorSubtitle: 'seatsErrorSubtitle',
                feedbackErrorButton: 'seatsErrorButton',
            },
        });
    },

    hide: function($e) {
        $e.addClass('odf-hidden');
    },

    show: function($e) {
        $e.removeClass('odf-hidden');
    },

    display: function($e, display) {
        $e.toggleClass('odf-hidden', !display);
    },

    scrollToTop: function() {
        if (Odigeo.SessionScope.flow === 'desktop') {
            this.$cachedSelectors.widget.animate({scrollTop: 0}, 300);
        } else {
            Odigeo.Utils.scrollToElement($('body'), {
                container: this.selectors.body,
                animation: false,
            });
        }
    },

    getSeatsTranslation: function() {
        return this.translations.seats;
    },

    renderWaiting: function(waitingMessage) {
        return this.tmpls.waitingTemplate(waitingMessage);
    },

    renderInfo: function(contentInfo) {
        return this.tmpls.infoTemplate(contentInfo);
    },

    renderFlightInfo: function(segmentsInfo) {
        return Odigeo._.reduce(segmentsInfo, function(acc, segment, segmentIndex) {
            return acc + this.renderFlightSectionInfo(segment, segmentIndex);
        }, '', this);
    },

    renderFlightSectionInfo: function(segment, segmentIndex) {
        var sections = segment.sections;
        var firstSection = sections[0].section;
        var lastSection = sections[sections.length - 1].section;
        var fromIata = firstSection.from.cityIataCode;
        var toIata = lastSection.to.cityIataCode;
        var from = firstSection.from.cityName;
        var to = lastSection.to.cityName;
        var date = Odigeo.Utils.formatDate(firstSection.departureDate, 'ddd, d mmm');
        var dateLong = Odigeo.Utils.formatDate(firstSection.departureDate, 'ddd, d mmm yyyy');
        var direction = segmentIndex === 0 ? 'right' : 'left';

        return this.tmpls.flightSectionInfoTemplate({
            direction: direction,
            fromIata: fromIata,
            toIata: toIata,
            from: from,
            to: to,
            date: date,
            dateLong: dateLong,
        });
    },

    renderCheckout: function() {
        var totalPrice = Odigeo.Utils.formatCurrency(this.widget.getTotalPrice(), this.widget.getCurrencyConfig());
        var totalSeats = this.getSeatsTranslation(this.widget.getTotalSeats(), -1, false);
        var showTotalSeats = this.widget.getTotalSeats() > 0;
        var enableCheckout = this.widget.hasSelectedAnySeat();
        var priceBreakdown = '';

        if (this.isPriceBreakdownOpen) {
            priceBreakdown = this.renderPriceBreakdown();
        }

        return this.tmpls.checkoutTemplate({
            totalPrice: totalPrice,
            totalPieces: totalSeats,
            showTotalPieces: showTotalSeats,
            priceBreakdown: priceBreakdown,
            isPriceBreakdownOpen: this.isPriceBreakdownOpen,
            enableCheckout: enableCheckout,
        });
    },

    renderPriceBreakdownItems: function() {
        var priceBreakdown = this.widget.getPriceBreakdown();
        var currencyConfig = this.widget.getCurrencyConfig();

        return Odigeo._.chain(priceBreakdown)
            .map(function(el) {
                return Odigeo._.extend(el, {
                    item: this.getSeatsTranslation(),
                    totalAmount: Odigeo.Utils.formatCurrency(el.totalAmount, currencyConfig),
                });
            }, this)
            .map(this.tmpls.priceBreakdownItemTemplate)
            .value()
            .join('');
    },

    renderPriceBreakdown: function() {
        var totalPrice = Odigeo.Utils.formatCurrency(this.widget.getTotalPrice(), this.widget.getCurrencyConfig());
        var totalSeats = this.getSeatsTranslation(this.widget.getTotalSeats(), -1, false);
        var priceBreakdownItems = this.renderPriceBreakdownItems();

        return this.tmpls.priceBreakdownTemplate({
            priceBreakdownItems: priceBreakdownItems,
            totalPieces: totalSeats,
            totalPrice: totalPrice,
            isSeatMap: true,
        });
    },

    renderPurchase: function() {
        var totalPrice = Odigeo.Utils.formatCurrency(this.widget.getTotalPrice(), this.widget.getCurrencyConfig());
        var enablePurchase = this.widget.allowPurchase();
        var priceBreakdown = '';
        var cardType = '';

        if (this.model.get('creditCardTypeName')) {
            cardType = Odigeo.Utils.replaceCmsKeyArgs(this.translations.cardType, this.model.get('creditCardTypeName'));
        }

        if (this.isPriceBreakdownOpen) {
            priceBreakdown = this.renderPriceBreakdown();
        }

        return this.tmpls.purchaseTemplate({
            totalPrice: totalPrice,
            enablePurchase: enablePurchase,
            priceBreakdown: priceBreakdown,
            isPriceBreakdownOpen: this.isPriceBreakdownOpen,
            cardType: cardType,
        });
    },

    renderNoCoveragePopup() {
        if (!this.$cachedSelectors.failure.html()) {
            const content = this.tmpls.noCoverageTemplate({
                imageClass: 'od-post-booking-seats-no-coverage-icon',
                title: this.translations.noCoverageTitle,
                subtitle: this.translations.noCoverageDescription,
                buttonLabel: this.translations.noCoverageButtonClose,
            });

            this.$cachedSelectors.failure.html(content);
        }
    },

    widgetInfo: function() {
        const phase = this.model.get('phase');
        const isLoading = phase === this.model.phases.LOADING;
        const isShopping = phase === this.model.phases.SHOPPING;
        const isCheckout = phase === this.model.phases.CHECKOUT;
        const isPayment = phase === this.model.phases.PAYMENT;
        const isBuying = phase === this.model.phases.BUYING;
        const isSuccess = phase === this.model.phases.SUCCESS;
        const isFailure = phase === this.model.phases.FAILURE;
        const isOneClickCheckoutInteraction = phase === this.model.phases.ONE_CLICK_CHECKOUT_INTERACTION;
        const isPaymentFailure = phase === this.model.phases.PAYMENT_FAILURE;
        const showFlightInfo = this.model.showFlightInfo();
        const showPayment = isPayment;
        const showHeaderTitle = !isSuccess && !isPaymentFailure && !isFailure;
        const showFooterBackLink = isFailure || isPaymentFailure || isSuccess;
        let segmentsInfo;
        let waitingMessage ='';
        let flightInfoContent ='';
        let checkoutContent = '';
        let purchaseContent = '';

        if (this.model.hasInfo()) {
            segmentsInfo = this.model.getSegmentsInfo();

            if (showFlightInfo && !isSuccess && !isFailure && !isPaymentFailure) {
                flightInfoContent = this.renderFlightInfo(segmentsInfo);
            }
        }

        if (isShopping || isCheckout) {
            checkoutContent = this.renderCheckout();
        }

        if (isPayment) {
            purchaseContent = this.renderPurchase();
        }

        if (isLoading) {
            waitingMessage = this.translations.loadingWaitingMessage;
        }

        if (isBuying) {
            waitingMessage = this.translations.buyingWaitingMessage;
        }

        const acillaryOptionsContainer = this.model.getAncillaryOptionsContainer();
        const debugInfo = Odigeo._.get(acillaryOptionsContainer, 'seatsDebugInfo');
        return {
            isLoading,
            isBuying,
            waitingMessage,
            showSeatMap: !(isSuccess || isFailure || isPaymentFailure || isOneClickCheckoutInteraction),
            isSuccess,
            isFailure,
            isOneClickCheckoutInteraction,
            isPaymentFailure,
            showHeaderTitle,
            showFlightInfo,
            showPayment,
            flightInfo: flightInfoContent,
            checkout: checkoutContent,
            purchase: purchaseContent,
            showFooterBackLink,
            debugInfo,
        };
    },

    //
    // View actions
    //

    render: function() {
        if (this.isOpen) {
            const widgetInfo = this.widgetInfo();
            const shouldDisplayContent = (!widgetInfo.isLoading && !widgetInfo.isBuying) || widgetInfo.isOneClickCheckoutInteraction;
            this.$cachedSelectors.waiting.html(this.renderWaiting(widgetInfo));

            if (widgetInfo.isFailure) {
                this.renderNoCoveragePopup();
            }

            this.display(this.$cachedSelectors.waiting, widgetInfo.isLoading || widgetInfo.isBuying);

            this.$cachedSelectors.info.html(this.renderInfo(widgetInfo));
            this.display(this.$cachedSelectors.seatMap, widgetInfo.showSeatMap);
            this.display(this.$cachedSelectors.failure, widgetInfo.isFailure);

            if (Odigeo.AB.isOneClickCheckout) {
                this.$cachedSelectors.purchase.html(widgetInfo.purchase);
                this.display(this.$cachedSelectors.content, shouldDisplayContent);
                this.display(this.$cachedSelectors.info, !widgetInfo.isBuying && !widgetInfo.isOneClickCheckoutInteraction);
                this.display(this.$cachedSelectors.purchase, !widgetInfo.isBuying);
            } else {
                this.display(this.$cachedSelectors.payment, widgetInfo.showPayment);
                this.$cachedSelectors.purchase.html(widgetInfo.purchase);
                this.display(this.$cachedSelectors.content, shouldDisplayContent);
                this.display(this.$cachedSelectors.success, widgetInfo.isSuccess);
                this.display(this.$cachedSelectors.paymentFailure, widgetInfo.isPaymentFailure);
            }

            this.afterRenderContent(widgetInfo);
            this.updateDomSelectorsToCache();
        }
    },

    removeContent: function() {
        this.beforeRemoveContent();
    },

    open: function() {
        this.widget.clearSeatSelections();
        this.render();
        this.toggleMainPageScroll(true);
        this.scrollToTop();
    },

    onCheckoutPaymentRetry() {
        this.model.set('phase', this.model.phases.PAYMENT_FAILURE);
    },

    close: function() {
        this.removeContent();
        this.toggleMainPageScroll(false);
        this.scrollToTop();

        if (Odigeo.AB.isOneClickCheckout) {
            this.oneClickCheckoutContainer.execute('cleanInputs');
        }
    },

    moveToPayment() {
        this.model.set('phase', this.model.phases.PAYMENT);
    },

    toggleMainPageScroll: function(isDisabling) {
        Odigeo.Device.getViewport().toggleClass('od-viewport-no-vertical-scroll', isDisabling);
    },

    //
    // Event handlers
    //

    onTapBack: function() {
        var action;
        var trackLabel = 'no-possible';
        if (this.model.get('phase') !== this.model.phases.FAILURE) {
            trackLabel = 'add';
        }
        if (this.model.get('seatAdded')) {
            action = 'add';
            trackLabel = 'added';
        }
        trackingUtils.trackEventWithCategory(
            CATEGORY, 'seats_offline_' + (action ? action : trackLabel),
            'seats_offline_' + trackLabel + '_close');

        this.model.set('seatAdded', false);
        Odigeo.trigger(this.widget.id + ':closeAddSeats');
    },

    onTapPhoneNumber: function() {
        trackingUtils.trackEventWithCategory(CATEGORY, 'seats_offline_no-possible', 'seats_offline_no-possible_call');
    },

    onCheckout: function() {
        SeatsTracking.trackSeatsWidgetClick('confirm');
        if (this.widget.hasSelectedAnySeat()) {
            if (Odigeo.AB.isOneClickCheckout) {
                this.oneClickCheckoutContainer.execute('togglePaymentForm', {
                    show: true,
                    isLoading: true,
                });
                this.widget.selectAncillariesAndAddToShoppingBasket();
            }

            Odigeo.trigger(this.widget.id + ':closeAircraftMap');
            this.model.set('phase', this.model.phases.PAYMENT);
            this.widget.trackPage('payment');
        }
    },

    onPriceBreakdownToggle: function() {
        this.isPriceBreakdownOpen = !this.isPriceBreakdownOpen;
        this.render();
    },

    onPurchase: function() {
        if (this.widget.allowPurchase()) {
            this.model.set('phase', this.model.phases.BUYING);

            if (Odigeo.AB.isOneClickCheckout) {
                this.oneClickCheckoutContainer.execute('checkout');
            } else {
                this.widget.purchaseSeats();
            }
        }
    },

    onCheckoutConfirm() {
        this.model.set('phase', this.model.phases.SUCCESS);
    },

    onCheckoutInteractionNeeded() {
        this.model.set('phase', this.model.phases.ONE_CLICK_CHECKOUT_INTERACTION);
    },
};
